import React from "react";

import { useMessageBoxContext } from "./context/MessageBoxContext";
import { MessageBoxPopupWidget1 } from "./variants/MessageBoxPopupWidget1";
import { MessageBoxSlideOutWidget1 } from "./variants/MessageBoxSlideOutWidget1";

export const MessageBoxFactory = () => {
  const { widget } = useMessageBoxContext();

  const variant = widget.variant;
  switch (variant) {
    case "messageBoxPopupWidget1":
      return <MessageBoxPopupWidget1 />;
    case "messageBoxSlideOutWidget1":
      return <MessageBoxSlideOutWidget1 />;
    default:
      // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
      console.error("Unrecognized message box widget: " + variant);
  }
};
